import axios from "axios";

const API_URL =
  "https://digital.webdoc.com.pk/Promotion/public/api/v1/service/fetch";

export const checkSubscription = async (apiService, msisdn) => {
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      body: JSON.stringify({
        api_service: apiService,
        msisdn,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error checking subscription:", error);
    return null;
  }
};

const VERIFY_API_URL =
  "https://digital.webdoc.com.pk/Promotion/public/api/v1/auth/verify";

export const userVerification = async (signature, inputData) => {
  try {
    const response = await fetch(VERIFY_API_URL, {
      method: "POST",
      body: JSON.stringify({
        data: inputData,
        signature,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error checking subscription:", error);
    return null;
  }
};
